module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-32-active.873e679b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-leaderboards-32-active.png
// module id = 3196
// module chunks = 11